import { Injectable } from '@angular/core';
import { Http,Headers,RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import {Storagehelper} from './storagehelper'


/*
  Generated class for the Webservice provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class Webservice {
	
	private webserviceurl: string;

	constructor(public http: Http,public stroage:Storagehelper) {
		// this.webserviceurl="http://app.dreamofthegood.org/api/DreamApi/";
		// this.webserviceurl="http://192.168.1.117/api/DreamApi/";

		this.webserviceurl="http://109.74.12.180/snorkel/api/DreamApi/";
	}

	public getAllData(){

		//1. Create promise
		//2. get all data from server
		//3. store all data into database
		//4. resolve the promise

		return new Promise<string>((resolve,reject)=>{
			this.fetchDataFromServer("GetAllData",{}).subscribe(
				data=>{
						this.stroage.saveDataFromServer(data).then(()=>{
							console.log("Looks like all data has been saved");
							resolve();
						})
						
					},
		    	err=>{

						console.log("error");
			    		reject("error");
				    });
		});
		
	}

	//get method name and params from methods to get data from server
	private fetchDataFromServer(method:string,params:Object){

		return this.http.get(this.webserviceurl+method,JSON.stringify(params)).map(res=>res.json());

	}

	public saveThought(params:Object){
		let headers = new Headers({
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		});
		let options = new RequestOptions({
			headers: headers
		});
		return this.http.post(this.webserviceurl+'SaveThought',JSON.stringify(params), options).map(res=>res.json());
	}

	public saveQuestion(params:Object){
		let headers = new Headers({
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		});
		let options = new RequestOptions({
			headers: headers
		});
		return this.http.post(this.webserviceurl+'SaveQuestion',JSON.stringify(params), options).map(res=>res.json());
	}


	replaceAll(string,search, replacement){
		var target = string;
		return target.replace(new RegExp(search, 'g'), replacement);
	}

	public saveAlternativeGroup(params:Object){
		let headers = new Headers({
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		});
		let options = new RequestOptions({
			headers: headers
		});
		var param={'headline':params['headline']};

  		param.headline=this.replaceAll(param.headline,' ','9a1');
		return this.http.post(this.webserviceurl+'saveAlternativeGroup',JSON.stringify(param), options).map(res=>res.json());
	}

	public saveAlternative(alternativetitle,alternativeGroup){
		let headers = new Headers({
			'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
		});
		let options = new RequestOptions({
			headers: headers
		});
		var param={'alternativeTitle':alternativetitle,'groupID':(alternativeGroup["group_id"]>1000) ? alternativeGroup["server_id"] : alternativeGroup["group_id"]};

  		param.alternativeTitle=this.replaceAll(param.alternativeTitle,' ','9a1');
		return this.http.post(this.webserviceurl+'saveAlternative',JSON.stringify(param), options).map(res=>res.json());
	}

}



// WEBPACK FOOTER //
// ./src/providers/webservice.ts